import React, { useContext } from 'react'
import { useState, useRef, useEffect } from 'react';
 

import StreamingAvatar from '@heygen/streaming-avatar';

import './Avatar.css'

import { AppContext } from '../Context/AppContext';

const Avatar = React.forwardRef(({ answer, showAvatarPopup, isConservation }, ref) => {

    const { grab, setAvatarId, setVoiceId, initialized, avatar, setDebug, fetchAccessToken, setInitialized, stream, play, updateVideo } = useContext(AppContext)
    // var toggleIn = false

    const [avatarDetails, setAvatarDetails] = useState();
    const [activeIndex, toggleActive] = useState("avatar_1");
    const [isDisabled, setIsDisabled] = useState(false);

    const mediaStream = useRef(null);
    const [toggleState, setToggle] = useState(false);

    const [isPlayedAvatar, setPlayAvatar] = useState(false);
    const [isMuteAvatar, setMuteAvatar] = useState(false);

    function slideToggle() {
        setToggle(prevState => !prevState)
        const slider = document.getElementById('avatar-icons-popup');
        const arrow = document.getElementById('slide_btn');

        if (toggleState === false) {
            slider.style.transform = 'translateX(-380px)';
            arrow.style.transform = 'rotate(180deg)';
        }
        else {
            slider.style.transform = 'translateX(0px)';
            arrow.style.transform = 'rotate(0deg)';
        }
    }

    function setAvatar(e, avatar) {
        // const icon = document.getElementById('chat-icon')
        let _avatar = {
            "id": "Wayne_20240711",
            "name": "Wayne_20240711",
            "icon": "avatar_1",
            "voice": {
                "id": "0ebe70d83b2349529e56492c002c9572",
                "language": "English",
                "gender": "Male"
            }
        }

        setCurrentAvatar(_avatar)
        setIsDisabled(false);
        // icon.style.backgroundImage = "url('assets/images/" + avatar.icon + ".jpg')";

    }
    async function setCurrentAvatar(avatar) {
        console.log("avatar: setCurrentAvatar:  ", avatar)
        toggleActive(avatar.icon)
        setAvatarId(avatar.id)
        setVoiceId(avatar.voice.id)
    }

    async function muteUnmuteAvatar(label) {

        if (!initialized || !avatar.current) {
            setDebug('Avatar API not initialized');
            return;
        }

        if (stream && mediaStream.current) {
            let _isMute = false;
            if (label === 'mute') {
                _isMute = true;
            }
            console.log("Avatar: muteUnmuteAvatar:  ", label);
            setMuteAvatar(_isMute);
            mediaStream.current.muted = _isMute
        }
    }


    async function playPauseAvatar(label) {
        if (!initialized || !avatar.current) {
            setDebug('Avatar API not initialized');
            return;
        }

        if (stream && mediaStream.current) {
            console.log("playPauseAvatar:  ", label);
            if (label === 'play') {
                mediaStream.current.play();
                setPlayAvatar(true);
            } else {
                mediaStream.current.pause();
                setPlayAvatar(false);
            }

        }

    }

    async function replayAvatar(label) {
        if (!initialized || !avatar.current) {
            setDebug('Avatar API not initialized');
            return;
        }

        if (stream && mediaStream.current) {
            console.log("replayAvatar:  ", label);
            if (label === 'replay') {
                mediaStream.current.pause(0);
                mediaStream.current.play(0);
                setPlayAvatar(true);
            }

        }

    }

    async function startStopAvatar(label) {
        if (!initialized || !avatar.current) {
            setDebug('Avatar API not initialized');
            return;
        }

        if (stream && mediaStream.current) {
            console.log("avatar startStopAvatar:  ", label);
            if (label === 'stop') {
                mediaStream.current.pause(0);
            } else {
                mediaStream.current.play(0);
            }

        }

    }



    async function fetchAvatarDetails() {

        try {
            const response = await fetch('./avatar_details.json', {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            const result = await response.json();
            setAvatarDetails(result);
            setCurrentAvatar(result.avatars[0])

        } catch (error) {
            console.error('Error fetching access :', error);
            return '';
        }
    }


    async function avatarInitialization() {

        try {

             await fetchAvatarDetails();

            const token = await fetchAccessToken();

            if (!token) {
                throw new Error("Access token is missing or invalid");
            }

            if (!token || avatar.current) return;

            avatar.current = new StreamingAvatar({
                token 
            });
   

        } catch (error) {
            console.error("Error during avatar initialization:", error);
        }

        try {
          //  await avatar.current.start(); // ✅ Required to activate avatar
            setInitialized(true);
        } catch (error) {
        }
    }

    useEffect(() => {

        if (stream && mediaStream.current) {
            mediaStream.current.srcObject = stream;
            mediaStream.current.events = {
                muteUnmuteAvatar,
                playPauseAvatar
            }

            muteUnmuteAvatar('mute');

            mediaStream.current.onloadedmetadata = () => {

                playPauseAvatar('play');
                updateVideo(mediaStream.current);
                
                window.addEventListener('message', function (event) {
                    console.log("Message received from the parent: " + event.data);
                    // Message received from parent
                    if ((event.data === 'play') || (event.data === 'pause')) {
                        playPauseAvatar(event.data);
                    } else if ((event.data === 'mute') || (event.data === 'unmute')) {
                        muteUnmuteAvatar(event.data);
                    } else if ((event.data === 'replay')) {
                        replayAvatar(event.data);
                    } else if ((event.data === 'stop') || (event.data === 'start')) {
                        startStopAvatar(event.data);
                    }
                });

            };
        }
    }, [mediaStream, setDebug, stream]);

    useEffect(() => {
        if (toggleState) {
            avatarInitialization();
        }
    }, [toggleState]);

    useEffect(() => {
        if (isConservation) {
            grab();
        }
    }, [isConservation]);

    return (
        <div className='avatar-icons-popup' id='avatar-icons-popup'>
            <button id='slide_btn' onClick={() => slideToggle()}></button>
            <div className='avatar-box'>
                <div className='selection-container'>
                    <div className='text-title'>
                        <h5>Select avatar </h5>
                    </div>
                    <div className='avatar-icons'>
                        {avatarDetails?.avatars?.map((avatar, index) => {
                            return (
                                <div className='image-box ' key={index}>
                                    <img
                                        className={(activeIndex === avatar.icon) && !isDisabled ? 'active' : ''}
                                        alt={`${avatar.icon}`}
                                        src={`assets/images/${avatar.icon}.jpg`}
                                        onClick={(e) => !isDisabled && setAvatar(e, avatar)}
                                        id={`image-box_${index}`}
                                        style={{ pointerEvents: isDisabled ? 'none' : 'auto', cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>



                {play && (
                    <div className='avatar'>
                        <video id='mediaStream_video'
                            playsInline
                            autoPlay
                            muted={false}
                            width={532}
                            height={299}
                            ref={mediaStream}
                            onCanPlay={() => {
                                setPlayAvatar('play');
                            }} />

                    </div>
                )
                }

                {!play && <div className='avatar-default'>{
                    // <video playsInline autoPlay width={500} height={300} src='assets/video/Chat_response_1.mp4' />                        
                }</div>
                }

                <div className='avatar-btns'>
                    <button id='play_btn' onClick={() => playPauseAvatar('play')} className={isPlayedAvatar ? 'nav_btn play_btn active hide' : 'nav_btn active'} >Play</button>
                    <button id='pause_btn' className={isPlayedAvatar ? 'nav_btn active' : 'nav_btn active hide'} onClick={() => playPauseAvatar('pause')}>Pause</button>
                    <button id='mute_btn' onClick={() => muteUnmuteAvatar('mute')} className={isMuteAvatar ? 'nav_btn active hide' : 'nav_btn active'}>Mute</button>
                    <button id='unmute_btn' onClick={() => muteUnmuteAvatar('unmute')} className={isMuteAvatar ? 'nav_btn active' : 'nav_btn active hide'}>Unmute</button>
                </div>
            </div>
        </div>

    );
});

export default Avatar